import {Injectable} from '@angular/core';
import {ChannelService} from '../../../../../micromate-learn-lib/src/lib/services/LearningChannelService';
import {
    LearningChannel,
    LearningChannelType
} from '../../../../../micromate-learn-lib/src/lib/components/profile/LearningChannel';

@Injectable({
    providedIn: 'root'
})
export class LearnChannelService implements ChannelService {
    public channel: LearningChannelType;

    constructor() {
        this.channel = LearningChannel.Learn;
    }

    public getChannel(): LearningChannelType {
        return this.channel;
    }

    public setChannel(): void {
        throw new Error('Not implemented');
    }
}
